import { useNavigate } from "react-router-dom";

import Button from "../../components/global/Button";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import logo404 from "../../assets/images/404.png";
const FirstScreen = () => {
  const navigate = useNavigate();
  const { not_found, shared }: DictionaryType = useGetDictionary();

  return (
    <div className="flex flex-col bg-white h-dvh">
      <div className="relative flex justify-center items-center h-full">
        <div className="absolute flex flex-col text-primary dark:text-whiteYellow justify-center items-center bg-white gap-5 transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
          <img loading="lazy" className=" w-[100vw]" src={logo404} alt="404" />
          <p className="text-primary dark:text-white text-[27px] py-5">
            Ooops! It seems you reached an incorrect URL.
          </p>
          <Button
            text={shared.back_home}
            customeStyle="bg-primaryYellow max-w-[650px] w-[100vw] text-primary dark:text-white text-[18px] rounded-full px-16 py-6"
            onClick={() => {
              // navigate(-2);
              navigate("/home");
            }}
            width="max-w-[650px] "
          />
        </div>
      </div>
    </div>
  );
};

export default FirstScreen;
